import { inject } from './AsyncScriptLoader';

function getPulsarTag() {
  return `
        var __nspid='7ia9f3';
        var __nsptags=[];
        (function(w, d) {
            var x = function() {
            var j=d.createElement("script");
            j.type="text/javascript";
            j.async=true;
            j.src="http"+(d.location.protocol==="https:"?"s://cs":"://c")+".ns1p.net/p.js?a="+__nspid;
            d.body.appendChild(j);
            }
            if(w.addEventListener) { w.addEventListener("load", x, false); }
            else if(w.attachEvent) { w.attachEvent("onload", x); }
            else { w.onload = x; }
        })(window, document);
    `;
}

// eslint-disable-next-line import/prefer-default-export
export const injectPulsarTag = () => inject('', getPulsarTag());
